import { SETTINGS_PATHS } from 'Features/routePaths';

export const settingsSidebarCommon = [
  {
    heading: 'Каналы',
    navlinks: {
      channels: 'Каналы отправки',
      'channel-types': 'Типы каналов',
    },
  },
  {
    heading: 'Коды и параметры',
    navlinks: {
      codes: 'Коды',
      'meteo-codes': 'Метеокоды',
      descriptors: 'Параметры',
      'code-descriptors': 'Коды и их параметры',
      'descriptor-types': 'Типы Параметров',
      // 'descriptor-values': 'Значение Параметра',
      // 'voc-code-values': 'Значение Кода',
    },
  },
  {
    heading: 'Станции',
    navlinks: {
      'station-cats': 'Категории станций',
      'station-types': 'Типы станций',
      'entity-types': 'Паспорт станции',
    },
  },
  {
    heading: 'Регионы',
    navlinks: {
      regions: 'Регионы',
      'region-types': 'Типы регионов',
    },
  },
  {
    heading: 'Источники данных',
    navlinks: {
      'datasource-type': 'Тип оборудования',
      vocmodes: 'Режимы работы',
      'datasource-statuses': 'Статусы источников данных',
      'datasource-seba-mapping-settings': 'Настройка каналов контроллеров',
    },
  },
  {
    heading: 'Программы',
    navlinks: {
      'observing-programs': 'Программы наблюдений',
      'device-types': 'Разделы датчиков',
      'program-type': 'Типы программ наблюдений',
      'sample-types': 'Типы замеров',
    },
  },
  {
    heading: 'Телеграммы',
    navlinks: {
      'telegram-keys': 'Параметры телеграмм',
      [SETTINGS_PATHS.telegramType]: 'Тип телеграмм',
    },
  },
  {
    heading: 'Списки',
    navlinks: {
      'datasource-statuses': 'Статусы',
      'voc-units': 'Единицы измерения',
      'settings-cron-expression': 'Настройка CRON выражений',
    },
  },
  {
    heading: 'События и Уведомления',
    navlinks: {
      'notification-event-types': 'Типы событий',
      'notification-types': 'Тип уведомлений',
      'notification-event-type-role-masks': 'Роли уведомлений',
      'notification-event-type-to-role-masks': 'Шаблоны уведомлений',
    },
  },
  {
    heading: 'Модель объектов',
    navlinks: {
      [SETTINGS_PATHS.hModels]: 'Жизненный цикл',
    },
  },
  // {
  //   heading: 'Хост',
  //   navlinks: {
  //     'host-controll': 'Управление хостом',
  //   },
  // },
];
